import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      nav("/app/projects");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative border-r border-border overflow-hidden">
        <div className="absolute inset-0 bg-marine" />
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="relative z-10 p-16 h-full flex flex-col justify-between text-white">
          <Logo />
          <div>
            <div className="label-mono text-[10px] text-gold">CITATION</div>
            <blockquote className="mt-4 font-serif text-3xl leading-tight">
              « Chaque dollar emprunté est une vie hypothéquée. »
            </blockquote>
            <p className="mt-6 text-sm text-white/70">— A. ELY Mustapha, <em>Théorie Nouvelle des Finances Publiques</em></p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="login-form">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-serif font-bold text-3xl">Connexion</h1>
          <p className="mt-2 text-muted-foreground text-sm">Accédez à votre espace d'analyse.</p>
          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" type="email" value={email}
                     onChange={(e) => setEmail(e.target.value)} required autoComplete="email" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password}
                     onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit-btn"
                    className="w-full h-11 bg-marine hover:bg-marine/90 text-white">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </div>
          <p className="mt-6 text-sm text-muted-foreground">
            Pas encore de compte ?{" "}
            <Link to="/register" data-testid="link-to-register" className="text-marine dark:text-gold font-semibold hover:underline">
              Créer un compte
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
